<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">

        <!-- Customização -->
        <div class="card menu-card" @click="openURL('site-customization')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-primary text-primary font-size-20">
                  <i class="mdi mdi-palette"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Customização</h5>
              <p class="text-muted mb-0">Cores, logos, banners e ordem das seções</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- Programação -->
        <div class="card menu-card" @click="openURL('site-schedules')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-info text-info font-size-20">
                  <i class="mdi mdi-calendar-clock"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Programação</h5>
              <p class="text-muted mb-0">Agenda completa com horários e palestras</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- Palestrantes -->
        <div class="card menu-card" @click="openURL('site-speakers')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-warning text-warning font-size-20">
                  <i class="mdi mdi-account-voice"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Palestrantes</h5>
              <p class="text-muted mb-0">Perfis e informações dos especialistas</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- Patrocinadores -->
        <div class="card menu-card" @click="openURL('site-sponsors')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-success text-success font-size-20">
                  <i class="mdi mdi-handshake"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Patrocinadores</h5>
              <p class="text-muted mb-0">Empresas e parceiros apoiadores</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- FAQs -->
        <div class="card menu-card" @click="openURL('site-faqs')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-danger text-danger font-size-20">
                  <i class="mdi mdi-help-circle"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Perguntas Frequentes</h5>
              <p class="text-muted mb-0">Respostas para dúvidas comuns</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- Depoimentos -->
        <div class="card menu-card" @click="openURL('site-testimonials')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-purple text-purple font-size-20">
                  <i class="mdi mdi-comment-quote"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Depoimentos</h5>
              <p class="text-muted mb-0">O que os participantes dizem sobre o evento</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- Fotos -->
        <div class="card menu-card" @click="openURL('site-photos')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-dark text-dark font-size-20">
                  <i class="mdi mdi-image-multiple"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Galeria de Fotos</h5>
              <p class="text-muted mb-0">Imagens e momentos especiais do evento</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- Vídeos -->
        <div class="card menu-card" @click="openURL('site-videos')">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-danger text-danger font-size-20">
                  <i class="mdi mdi-play-circle"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Vídeos</h5>
              <p class="text-muted mb-0">Vídeos do YouTube ou Vimeo embedados na LP</p>
            </div>
            <div class="flex-shrink-0">
              <i class="mdi mdi-chevron-right font-size-24 text-muted"></i>
            </div>
          </div>
        </div>

        <!-- WhatsApp Support -->
        <!-- <div class="card menu-card-toggle">
          <div class="card-body d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <div class="avatar-sm">
                <span class="avatar-title bg-soft-success text-success font-size-20">
                  <i class="mdi mdi-whatsapp"></i>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="font-size-15 mb-1 text-dark">Suporte WhatsApp Visível</h5>
              <p class="text-muted mb-0">Exibir botão flutuante de WhatsApp no site</p>
            </div>
            <div class="flex-shrink-0">
              <b-form-checkbox
                v-model="setting.support_whatsapp"
                switch
                size="lg"
                @change="updateSupport()"
              ></b-form-checkbox>
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'setting-event',
  page: {
    title: 'Site do evento',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      submitted: false,
      setting: {},
      title: 'Site do evento',
      items: [
        {
          text: 'Configurações gerais',
          href: '/settings'
        },
        {
          text: 'Site do evento',
          active: true
        }
      ]
    }
  },
  mounted () {
    this.GetSetting().then(() => {
      this.setting = this.data
    })
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settingEvent', { data: 'setting' })
  },
  methods: {
    ...mapActions('settingEvent', {
      GetSetting: 'GetSetting',
      postSetting: 'SaveSetting'
    }),
    async updateSupport () {
      let loader = this.$loading.show()
      try {
        await this.postSetting({
          id: this.setting.id,
          support_whatsapp: this.setting.support_whatsapp
        }).then(() => {
          successMessage('Dados atualizados com sucesso.', 2500)
          loader.hide()
        })
      } catch (err) {
        console.log(err)
        loader.hide()
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    openURL (url) {
      this.$router.push({ name: url })
    }
  }
}
</script>

<style scoped>
.menu-card {
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 15px;
  border: 1px solid #e9ecef;
}

.menu-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
  border-color: #556ee6;
}

.menu-card:hover h5 {
  color: #556ee6 !important;
}

.menu-card:hover .mdi-chevron-right {
  color: #556ee6 !important;
}

.menu-card-toggle {
  margin-bottom: 15px;
  border: 1px solid #e9ecef;
}

.menu-card-toggle:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
  display: inline-block;
}

.avatar-title {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
  border-radius: 0.5rem;
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.18) !important;
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.18) !important;
}

.bg-soft-warning {
  background-color: rgba(242, 184, 73, 0.18) !important;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.18) !important;
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.18) !important;
}

.bg-soft-purple {
  background-color: rgba(108, 92, 231, 0.18) !important;
}

.bg-soft-dark {
  background-color: rgba(52, 58, 64, 0.18) !important;
}

.text-purple {
  color: #6c5ce7 !important;
}
</style>
